// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.3.0",
  date: "2026-07-20T15:33:55.472Z",
  gitInfo: {
    dirty: false,
    raw: "01295b96c",
    hash: "01295b96c",
    distance: null,
    tag: null,
    semver: null,
    suffix: "01295b96c",
    semverString: null
  }
};
/* tslint:enable */
